export enum WireFeedTypes {
    RSS = 0,
    AP = 1,
    TWITTER = 2,
    FTP = 4,
    SFTP = 5,
}
